import React from "react";

const toneStyles = {
  neutral: {
    card: "border-line bg-gradient-to-br from-white via-subtle/40 to-white",
    value: "text-ink",
    label: "text-muted",
    chip: "bg-subtle text-inkSecondary",
    glow: "bg-main/20",
  },
  success: {
    card: "border-success/20 bg-gradient-to-br from-successSoft via-white to-success/70",
    value: "text-success",
    label: "text-success/80",
    chip: "bg-successSoft text-success",
    glow: "bg-success/30",
  },
  danger: {
    card: "border-danger/20 bg-gradient-to-br from-dangerSoft via-white to-danger/70",
    value: "text-danger",
    label: "text-danger/80",
    chip: "bg-dangerSoft text-danger",
    glow: "bg-danger/30",
  },
  warning: {
    card: "border-warning/20 bg-gradient-to-br from-warningSoft via-white to-warning/70",
    value: "text-warning",
    label: "text-warning/80",
    chip: "bg-warningSoft text-warning",
    glow: "bg-warning/35",
  },
  info: {
    card: "border-info/20 bg-gradient-to-br from-infoSoft via-white to-info/70",
    value: "text-info",
    label: "text-info/80",
    chip: "bg-infoSoft text-info",
    glow: "bg-info/30",
  },
  brand: {
    card: "border-main/25 bg-gradient-to-br from-main/10 via-white to-main/5",
    value: "text-main",
    label: "text-main/80",
    chip: "bg-main/15 text-main",
    glow: "bg-main/25",
  },
};

const MetricCard = ({
  title,
  value,
  subtitle,
  chipText,
  tone = "neutral",
  icon: Icon,
  onClick,
  className = "",
  compact = false,
}) => {
  const styles = toneStyles[tone] || toneStyles.neutral;
  const Wrapper = onClick ? "button" : "div";

  return (
    <Wrapper
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`group relative isolate overflow-hidden w-full rounded-2xl border p-4 text-left shadow-soft transition-all duration-300 ${
        styles.card
      } ${onClick ? "hover:-translate-y-1 hover:shadow-card cursor-pointer" : "hover:shadow-card"} ${
        compact ? "p-3" : "p-4 sm:p-5"
      } ${className}`}
    >
      <div className="absolute inset-x-0 top-0 h-1.5 rounded-t-2xl bg-gradient-to-r from-white/0 via-white/70 to-white/0 pointer-events-none" />
      <div
        className={`absolute -right-10 -top-10 h-28 w-28 rounded-full blur-2xl transition-opacity duration-300 ${styles.glow} opacity-70 group-hover:opacity-100`}
      />
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(120deg,rgba(255,255,255,0)_20%,rgba(255,255,255,0.45)_50%,rgba(255,255,255,0)_80%)] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className={`text-[11px] font-semibold uppercase tracking-[0.12em] ${styles.label}`}>
            {title}
          </p>
          <p className={`mt-1 font-extrabold tabular-nums break-words leading-tight ${styles.value} ${compact ? "text-xl" : "text-2xl sm:text-3xl"}`}>
            {value}
          </p>
          {subtitle && (
            <p className="mt-1 text-xs text-muted break-words">{subtitle}</p>
          )}
        </div>

        {(Icon || chipText) && (
          <div className="flex items-start gap-2 shrink-0">
            {chipText && (
              <span className={`rounded-full border border-white/50 px-2.5 py-1 text-[10px] font-semibold shadow-soft ${styles.chip}`}>
                {chipText}
              </span>
            )}
            {Icon && (
              <div className={`h-10 w-10 rounded-xl flex items-center justify-center shadow-soft ring-1 ring-white/60 ${styles.chip}`}>
                <Icon size={18} />
              </div>
            )}
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default MetricCard;
